import { HC_STM_DOMAIN } from 'core/constants/endpoints'
import { cleanDomainName } from 'utils/cleanDomainName'

function isHcStmDomain() {
  const cleanDomain = cleanDomainName({ hostName: window.location.hostname })
  return HC_STM_DOMAIN === cleanDomain
}
export default isHcStmDomain
